export default function ArrowRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.556" viewBox="0 0 16 15.556">
            <path id="Path_375" data-name="Path 375" d="M16.172,11,10.808,5.636l1.414-1.414L20,12l-7.778,7.778-1.414-1.414L16.172,13H4V11Z" transform="translate(-4 -4.222)" fill="#fcfcfc"/>
        </svg>
    )
}